(function () {
  function initGuide(root) {
    if (root.dataset.uagBound === 'true') return;
    root.dataset.uagBound = 'true';

    root.addEventListener('click', function (e) {
      const trigger = e.target.closest('._uag-faq-trigger');
      if (!trigger || !root.contains(trigger)) return;

      const item = trigger.closest('._uag-faq-item');
      if (!item) return;

      const willOpen = !item.classList.contains('-open');
      const list = item.closest('._uag-faq-list');
      if (list) {
        list.querySelectorAll('._uag-faq-item.-open').forEach(function (open) {
          if (open === item) return;
          open.classList.remove('-open');
          const t = open.querySelector('._uag-faq-trigger');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }

      item.classList.toggle('-open', willOpen);
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });

    const tocInner = root.querySelector('[data-uag-toc]');
    const tocToggle = root.querySelector('._uag-toc-toggle');
    if (tocInner && tocToggle) {
      tocToggle.addEventListener('click', function () {
        const open = tocInner.classList.toggle('-open');
        tocToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      tocInner.addEventListener('click', function (e) {
        if (!e.target.closest('._uag-toc-link')) return;
        if (window.matchMedia('(max-width: 860px)').matches) {
          tocInner.classList.remove('-open');
          tocToggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    const links = Array.prototype.slice.call(
      root.querySelectorAll('._uag-toc-link[data-uag-toc-link]')
    );
    if (!links.length) return;

    const linkById = {};
    const targets = [];
    links.forEach(function (link) {
      const id = link.getAttribute('data-uag-toc-link');
      const target = document.getElementById(id);
      if (!target) return;
      linkById[id] = link;
      targets.push(target);
    });
    if (!targets.length) return;

    let activeId = null;
    let pendingClickId = null;
    let scrollEndTimer = null;
    let scrollTicking = false;

    function setActive(id, force) {
      if (!linkById[id]) return;
      if (!force && id === activeId) return;
      activeId = id;
      links.forEach(function (l) { l.classList.remove('-active'); });
      linkById[id].classList.add('-active');
    }

    function clearActive() {
      if (activeId === null) return;
      activeId = null;
      links.forEach(function (l) { l.classList.remove('-active'); });
    }

    function getScrollOffset() {
      let margin = parseFloat(getComputedStyle(targets[0]).scrollMarginTop);
      if (!margin || Number.isNaN(margin)) {
        margin = window.innerHeight * 0.15;
      }
      return margin;
    }

    function getAbsoluteTop(el) {
      return el.getBoundingClientRect().top + window.pageYOffset;
    }

    function updateActiveFromScroll() {
      if (pendingClickId) return;
      const scrollPos = window.pageYOffset + getScrollOffset();
      let currentId = null;
      for (let i = 0; i < targets.length; i++) {
        if (getAbsoluteTop(targets[i]) <= scrollPos + 1) {
          currentId = targets[i].id;
        }
      }
      if (currentId) {
        setActive(currentId);
      } else {
        clearActive();
      }
    }

    function finishScrollInteraction() {
      if (pendingClickId) {
        setActive(pendingClickId, true);
        pendingClickId = null;
      } else {
        updateActiveFromScroll();
      }
    }

    function scheduleScrollEnd() {
      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(finishScrollInteraction, 150);
    }

    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        const id = link.getAttribute('data-uag-toc-link');
        const target = id ? document.getElementById(id) : null;
        if (!id || !target || !linkById[id]) return;

        e.preventDefault();
        pendingClickId = id;
        setActive(id, true);

        if (history.replaceState) {
          history.replaceState(null, '', '#' + id);
        } else {
          location.hash = id;
        }

        target.scrollIntoView({ block: 'start' });
        scheduleScrollEnd();
      });
    });

    window.addEventListener('scroll', function () {
      if (pendingClickId) {
        scheduleScrollEnd();
        return;
      }
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(function () {
        updateActiveFromScroll();
        scrollTicking = false;
      });
    }, { passive: true });

    const hash = window.location.hash.slice(1);
    if (hash && linkById[hash]) {
      setActive(hash, true);
    }
  }

  function initAll() {
    document.querySelectorAll('.uric_guide ._uag').forEach(initGuide);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();